import {  GentleAccentedContentCard } from '../../atoms/ContentCard';
import { TopicName as TechTopicName, TechTopicNameToComponent } from '../TechnologyTopic/TechnologyTopic';
import styled from 'styled-components';

export const ProjectRole = {
    seniorDev: "Senior Consultant Developer",
    volunteerDev:  "Volunteer Developer",
    selfLed:  "Self-led",
} 

export interface LogoImage {
    image: any,
    link?: string,
    border?: boolean
}

interface ProjectCardProps {
    projectNamei18n: String;
    link?: string;
    projectResponsibilities18n: String;
    techStackItems?: TechTopicName[];
    logos?: LogoImage[];
    role?: string;
}


const TechIconsContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto auto auto auto auto auto auto auto auto;
  align-content: center;
  justify-content: center;

  @media (max-width: 1200px) {
    grid-template-columns: auto auto auto auto auto auto;
  };

    @media (max-width: 800px) {
    grid-template-columns: auto auto auto auto ;
  };

    @media (max-width: 600px) {
    grid-template-columns: auto auto auto;
  };
      @media (max-width: 450px) {
    grid-template-columns: auto auto;
  };
  `;

  const LogosContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  align-content: center;
  justify-content: center;


@media (max-width: 800px) {

    img {
        max-width: 600px;
    }

    grid-template-columns: auto auto;
  };

      @media (max-width: 600px) {

    img {
        max-width: 400px;
    }

    grid-template-columns: auto auto;
  };

    @media (max-width: 450px) {

    img {
        max-width: 200px;
    }

    grid-template-columns: auto;
  };
  `;


export const ProjectBlock: React.FC<ProjectCardProps> = (props: ProjectCardProps) => {

    const techSprites = props.techStackItems?.map(topic => TechTopicNameToComponent(topic));
    const logos = props.logos?.map(img => 
    <a href={img.link} target="_blank" rel="noreferrer" style={{margin: "10px"}}>
        <img src={img.image} 
        alt={img.link}
        style={{ maxHeight: '10rem', borderRadius: "4px", border: img.border ? "solid" : "none",padding: "4px", borderWidth: "0.1rem" }}>

        </img>
    </a>
        )

    return (
        <>
            <GentleAccentedContentCard style={{ padding: '10px', textAlign: 'center' }}>
                <h4>
                    <a href={props.link} rel="noreferrer" target="_blank">
                        {props.projectNamei18n}
                    </a>
                </h4>
                <LogosContainer style={{justifyContent: "center"}}>
                    {logos}
                </LogosContainer>
                <br />
                <div style={{ marginTop: '10px', fontStyle: 'italic' }}>
                    {props.role && <>Role: {props.role}</>}
                </div>
                <br />
                <div style={{ marginTop: '10px', fontStyle: 'italic' }}>
                    {props.projectResponsibilities18n}
                </div>
                <br />
                <TechIconsContainer>
                    {techSprites}
                </TechIconsContainer>
            </GentleAccentedContentCard>
        </>
    );
};

export default ProjectBlock;